import { useContext, useState, useEffect } from "react";
import { passwordValidation, removeTokens, separateRoles, toBase64 } from "../../helpers/HelperFunctions";
import moment from "moment";
import Camera from "../../assets/images/Camera.svg";
import Input from "../../components/Input/Input";
import DocumentButton from "../../components/DocumentButton/DocumentButton";
import { User } from "../../store/Store";
import MuiAlert from "../../components/Alert/Alert";
import FileProgress from "../../components/FileProgress/FileProgress";

import "./Settings.scss";
import ApiService from "../../services/ApiService";
import { addMedia, firebaseSignOut } from "../../helpers/FirebaseFunctions";
import { useNavigate } from "react-router-dom";


export function SettingsAccount() {

  const [formData, setFormData] = useState({
    profileImageUrl: "", firstName: "", lastName: "", email: "",
    currentPassword: "", newPassword: "", confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });
  const [user] = useContext(User);

  const [formDataErrors, setFormDataErrors] = useState({
    emailError: { showError: false, message: "" }, newPasswordError: { showError: false, message: "" },
    confirmPasswordError: { showError: false, message: "" },
  });

  const apiService = new ApiService();
  const navigate = useNavigate();


  useEffect(() => {
    if (user) {
      loadData();
    }
  }, [user])

  function handleLogout() {
    apiService.logout().finally(async () => {
      removeTokens();
      await firebaseSignOut();
      navigate("/login");
      setLoading(false);
    });
  }

  async function changeSettings() {

    setLoading(true);

    let _data = {
      profileImageUrl: "",
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: user?.email,
      newEmail: formData.email,
      roles: user?.roles,
      status: true,
    }

    apiService.updateUser(_data).then((result) => {

      let data = result.data;

      if (!data?.isSuccessful) {
        let newShowAlert = showAlert;
        newShowAlert.isError = true;
        newShowAlert.message = data?.errorMessage;
        newShowAlert.open = true;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        return;
      }

      if (_data.email != _data.newEmail) {
        handleLogout();
      }
      let newShowAlert = showAlert;
      newShowAlert.isError = false;
      newShowAlert.message = "Updated";
      newShowAlert.open = true;
      setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));


    }).catch(() => {
      let newShowAlert = showAlert;
      newShowAlert.isError = true;
      newShowAlert.message = "Unexpected Error";
      newShowAlert.open = true;
      setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }).finally(() => {
      setLoading(false);
    });

    // if (formData.newPassword !== formData.confirmPassword) {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.newPasswordError.showError = true;
    //   newFormDataErrors.newPasswordError.message = "PASSWORDS DO NOT MATCH";
    //   newFormDataErrors.confirmPasswordError.showError = true;
    //   newFormDataErrors.confirmPasswordError.message = "PASSWORDS DO NOT MATCH";
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    //   setLoading(false);
    //   return;
    // } else {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.newPasswordError.showError = false;
    //   newFormDataErrors.confirmPasswordError.showError = false;
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    // }

    // if (!passwordValidation(formData.newPassword?.trim())) {
    //   let newShowAlert = showAlert;
    //   newShowAlert.isError = true;
    //   newShowAlert.message = "Password must be at least 8 characters long and must also contain an upper case letter, "
    //     + "a number and a special character";
    //   newShowAlert.open = true;
    //   setLoading(false);
    //   return;
    // }

    // if (formData.email.trim() === "") {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.emailError.showError = true;
    //   newFormDataErrors.emailError.message = "ENTER YOUR EMAIL ADDRESS";
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    //   setLoading(false);
    //   return;
    // } else {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.emailError.showError = false;
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    // }

    // if (formData.newPassword.trim() === "") {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.newPasswordError.showError = true;
    //   newFormDataErrors.newPasswordError.message = "ENTER A VALID PASSWORD";
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    //   setLoading(false);
    //   return;
    // } else {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.newPasswordError.showError = false;
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    // }

    // if (formData.confirmPassword.trim() === "") {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.confirmPasswordError.showError = true;
    //   newFormDataErrors.confirmPasswordError.message = "ENTER A VALID PASSWORD";
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    //   setLoading(false);
    //   return;
    // } else {
    //   let newFormDataErrors = formDataErrors;
    //   newFormDataErrors.confirmPasswordError.showError = false;
    //   setFormDataErrors(prevDetails => ({ ...prevDetails, ...newFormDataErrors }));
    // }
  }

  function loadData() {
    let newFormData = formData;
    newFormData.profileImageUrl = user?.profileImageUrl;
    newFormData.firstName = user?.firstName;
    newFormData.lastName = user?.lastName;
    newFormData.email = user?.email;
    setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
  }

  return (
    <div className="content">
      <MuiAlert error={showAlert.isError} message={showAlert.message} open={showAlert.open}
        onClose={() => {
          let newShowAlert = showAlert;
          newShowAlert.open = false;
          setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
        }} />
      <div className="section-padding animated animatedFadeInUp fadeInUp">
        <span className="heading">Account Settings</span>
        <span className="sub">Update your account settings</span>
      </div>
      <div className="form-box animated animatedFadeInUp fadeInUp">
        <div className="user-image animated animatedFadeInUp fadeInUp">
          <FileProgress name={user?.firstName + " " + user?.lastName} style={"user-img"} />
          {/* <span className="camera-background">
            <input id="file" type="file" name="fileUpload" accept={"images/*"}
              onChange={async (e: any) => {
                console.log('file', e.target.files[0]);
                await toBase64(e.target.files[0]).then((base64Url: any) => {
                  let url = base64Url;
                  setPictureUrl(url);
                  let personalDetails = formData;
                  personalDetails.profileImageUrl = url;
                  setFormData((preDetails: any) => ({ ...preDetails, ...personalDetails }));
                });
              }} />
            <label htmlFor="file">
              <img className="user-img" src={Camera} alt="Camera" />
            </label>
          </span> */}
          <div className="data" style={{ marginLeft: "10px" }}>
            <label className="header">{separateRoles(user?.roles)}</label>
            <div className="detail">Member since - {moment.utc(user?.joinedDate).format("DD-MM-YYYY")}</div>
          </div>
        </div>
        <div className="section padding form animated animatedFadeInUp fadeInUp">
          <span className="account-sub-section-heading">
            Personal Details
          </span>
          <div className="account-sub-section-row">
            <div className="input-content">
              <Input label="FIRST NAME*" value={formData.firstName} showError={false} type={"text"}
                onChange={(value: string) => {
                  let newFormData = formData;
                  newFormData.firstName = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
            <div className="input-content">
              <Input label="LAST NAME*" value={formData.lastName} showError={false} type={"text"}
                onChange={(value: any) => {
                  let newFormData = formData;
                  newFormData.lastName = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
            <div className="input-content">
              <Input label="EMAIL ADDRESS*" value={formData.email} type={"text"}
                onChange={(value: any) => {
                  let newFormData = formData;
                  newFormData.email = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
          </div>
        </div>
        {/* <div className="section padding form animated animatedFadeInUp fadeInUp">
          <span className="account-sub-section-heading">Password</span>
          <div className="account-sub-section-row">
            <div className="input-content">
              <Input label="CURRENT PASSWORD*" value={formData.currentPassword}
                showError={false} type={"password"}
                onChange={(value: any) => {
                  let newFormData = formData;
                  newFormData.currentPassword = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
            <div className="input-content">
              <Input label="NEW PASSWORD*" value={formData.newPassword} showError={formDataErrors.newPasswordError.showError}
                type={"password"}
                onChange={(value: any) => {
                  let newFormData = formData;
                  newFormData.newPassword = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
            <div className="input-content">
              <Input label="CONFIRM PASSWORD*" value={formData.confirmPassword} showError={formDataErrors.confirmPasswordError.showError} type={"password"}
                onChange={(value: any) => {
                  let newFormData = formData;
                  newFormData.confirmPassword = value;
                  setFormData((preDetails) => ({ ...preDetails, ...newFormData }));
                }} />
            </div>
          </div>
        </div> */}
        <div className="button animated animatedFadeInUp fadeInUp">
          <div className="update-button">
            <DocumentButton loading={loading} onClick={() => { changeSettings(); }} text={"Update Details"} />
          </div>
        </div>
      </div>
    </div>
  )
}








